const common = {
  'brand': 'USFans Spreadsheet',
  'nav.home': 'Home',
  'nav.shoppingGuide': 'Shopping Guide',
  'nav.categories': 'Categories',
  'nav.guides': 'Guides',
  'nav.reviews': 'Reviews',
  'nav.safety': 'Safety',
  'nav.cta': 'Buy It Now',
  'common.readMore': 'Read More',
  'common.updated': 'Updated',
  'common.mainSite': 'Visit Main Website',
  'common.backHome': 'Back to Home',
  'footer.tagline': 'An independent resource hub helping you organize USFans spreadsheet resources, product lists, seller information and buying guides in one place.',
  'footer.navTitle': 'Navigation',
  'footer.resourcesTitle': 'Resources',
  'footer.categories': 'Categories',
  'footer.guides': 'Guides',
  'footer.reviews': 'Reviews',
  'footer.safety': 'Safety Center',
  'footer.disclaimer': 'This website is an independent informational resource. Always verify websites, sellers, links, prices and transaction details independently before taking any action.',
  'footer.rights': 'All rights reserved.',
  'lang.english': 'English',
  'lang.polish': 'Polski',
  'lang.spanish': 'Español',
  'lang.french': 'Français',
};

export default common;